import { render } from "./App.vue?vue&type=template&id=2ce24b4d"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/home/marwin/projects/123parebrise/appointment-module/src-js/frontend-shortcode-appointment-module/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__